import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import fr from "./locales/fr.json";
import en from "./locales/en.json";

const dictionaries = { fr, en };
const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("fr");

  useEffect(() => {
    try {
      const saved = localStorage.getItem("lang");
      if (saved) {
        setLang(saved);
        return;
      }
    } catch {}
    const browser = typeof navigator !== "undefined" && navigator.language?.toLowerCase().startsWith("fr") ? "fr" : "en";
    setLang(browser);
  }, []);

  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.fr;
    const t = (key, fallback = key) => {
      try {
        return key.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), dict) ?? fallback;
      } catch {
        return fallback;
      }
    };
    return { lang, setLang, t };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
}
